<template>
  <div style="height:100%">
    <!-- <SplitContainer2 style="height:100%" layout="horizontal">
      <template #table1> -->
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="ApproveUserSettingRef" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[1, 1, 0, 0, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed"
        @on_cell_button_click="on_cell_button_click">
        <template #query>
          {{ $t("common.initiator") }}：<el-input size="small" v-model="DocumentCreateBy"
            style="width: 120px"></el-input>
          {{ $t("common.approver") }}：<el-input size="small" v-model="Approver" style="width: 120px"></el-input>
          {{ $t("common.approved") + $t("common.type") }}：<el-select filterable v-model="ApproveTypeSettingId"
            placeholder="请选择审批类型" size="small" clearable>
            <el-option v-for="item in ApprovedTypeOptions1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template #toolbar="">
          <el-button type="info" plain @click="createForm('new')" class="ml-2 iconfont icon-add-new" size="mini">
            {{ $t("common.new") }}
          </el-button>
        </template>
      </TableMain>
    </BaseContainer>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-col :span="24">
            <el-form-item :label="$t('common.approved') + $t('common.type')" prop="ApproveTypeSettingId">
              <el-select filterable v-model="dataForm.ApproveTypeSettingId"
                :placeholder="$t('common.approved') + $t('common.type')" clearable
                @change="ApproveTypeChanged(dataForm.ApproveTypeSettingId)">
                <el-option v-for="item in ApprovedTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('common.initiator')" prop="DocumentCreateBy">
              <el-select v-model="dataForm.DocumentCreateBy" filterable :placeholder="$t('common.initiator')" clearable>
                <el-option v-for="item in UserOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.approved') + $t('common.grade')" prop="ApproveLevel">
              <el-select v-model="dataForm.ApproveLevel" :placeholder="$t('common.approved') + $t('common.grade')">
                <el-option v-for="item in LevelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.approver')" prop="Approver">
              <el-select v-model="dataForm.Approver" :placeholder="$t('common.approver')" filterable clearable>
                <el-option v-for="item in ApprovedUserOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="" prop="isRole">
              <el-checkbox :label="$t('common.isRole')" v-model="dataForm.isRole" @change="changeRole"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.approve_rules')" prop="ApproveRule">
              <el-input v-model="dataForm.ApproveRule" type="textarea" rows="5"
                :placeholder="$t('common.approve_rules')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="" prop="is_valid">
              <el-checkbox :label="$t('common.valid')" v-model="dataForm.is_valid"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import * as ApproveTypeSettingController from "../../controllers/system/ApproveTypeSettingController"
import * as ApproveUserSettingController from "../../controllers/system/ApproveUserSettingController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import BaseContainer from "../components/BaseContainer"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_approve_process",
      },
      modal_title: "create_approve_process",
      fields: ApproveUserSettingController.fields,
      dataForm: _.cloneDeep(ApproveUserSettingController.dataForm),
      rules: ApproveUserSettingController.rules,
      DocumentCreateBy: "",
      Approver: "",
      ApprovedTypeOptions: [],
      ApprovedTypeOptions1: [],
      // UserOptions: [],
      ApprovedUserOptions: [],
      LevelOptions: [],
      typeList: [],
      ApproveTypeSettingId: ""
    }
  },
  computed: {
    UserOptions() {
      let _UserOptions = []
      // let _result = await UserManageController.methods.getData();
      let _result = this.$store.state.biz_data.baseData.Users
      if (_result && _result.length > 0) {
        _.each(_result, (t) => {
          _UserOptions.push({
            value: t.username,
            label: t.username,
          })
        })
      }
      return _UserOptions
    },
  },
  created() {
    this.getApprovedType()
    this.initLevelOptions(1)
  },
  methods: {
    async changeRole(val) {
      this.dataForm.Approver = ""
      this.dataForm.isRole = val
      await this.getApprovedUser()

    },
    async getApprovedType() {
      let _result = await ApproveTypeSettingController.methods.getData({
        id: { ">": 0 },
      })
      if (_result && _result[0].length > 0) {
        let datas = _result[0]
        this.typeList = datas
        _.each(datas, (t) => {
          this.ApprovedTypeOptions.push({
            value: t.id,
            label: t.DocumentType + " : " + t.description,
            ApproveLevel: t.ApproveLevel
          })
          this.ApprovedTypeOptions1.push({
            value: t.id,
            label: t.DocumentType + " : " + t.description,
            ApproveLevel: t.ApproveLevel
          })
        })
      }
    },

    async getApprovedUser() {
      this.ApprovedUserOptions = []

      if (this.dataForm.isRole) {
        //切换审批人为角色
        this.ApprovedUserOptions = await this.getRole()
      } else {
        this.ApprovedUserOptions = this.UserOptions
      }
    },
    async getRole() {
      let _ApprovedUserOptions = []
      let _result = await RoleManageController.methods.GetRoleList()
      _result = _.filter(_result, { is_sys: false })
      if (_result && _result.length > 0) {
        _.each(_result, (t) => {
          _ApprovedUserOptions.push({
            value: t.code,
            label: t.code + " : " + t.name,
          })
        })
      }
      return _ApprovedUserOptions
    },
    ApproveTypeChanged(v) {
      this.LevelOptions = []
      let at = _.find(this.ApprovedTypeOptions, { value: v })
      if (at) {
        this.initLevelOptions(parseInt(at.ApproveLevel))
      }
    },
    initLevelOptions(len) {
      for (var i = 1; i <= len; i++) {
        this.LevelOptions.push({ value: i, label: i })
      }
    },
    //#region 查询
    async on_query(set_data) {
      let _params = { id: { ">": 0 } }
      if (this.DocumentCreateBy != "") {
        _params.DocumentCreateBy = { like: "%" + this.DocumentCreateBy + "%" }
      }
      if (this.Approver != "") {
        _params.Approver = { like: "%" + this.Approver + "%" }
      }
      if (this.ApproveTypeSettingId != "") {
        _params.ApproveTypeSettingId = { "=": this.ApproveTypeSettingId }
      }
      let _result = await ApproveUserSettingController.methods.getData(_params)

      console.log(this.typeList)

      if (_result && _result[0].length > 0) {
        //set_data(_result[0]);
        _.each(_result[0], (t) => {
          t.description = _.find(this.typeList, {
            id: t.ApproveTypeSettingId,
          }).description
        })
        set_data(_.orderBy(_result[0], ["id"], ["asc"]))
        //this.$refs.ApproveUserSettingRef.showValidItems()
      } else {
        set_data([])
      }
    },
    ///cell click
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    async createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "新增审批流程"
          this.dataForm = _.cloneDeep(ApproveUserSettingController.dataForm)
          break
        case "edit":
          title = "编辑审批流程"
          break
      }
      this.modal_title = title
      await this.getApprovedUser()
      this.$refs.bvModal.show()
    },
    ValidData() {
      // if (this.dataForm.Approver == "" && this.dataForm.ApproveRule == "") {
      //   this.msgToasts("审批人和审批规则不能同时为空!", "info");
      //   return false;
      // }
      if (this.dataForm.Approver != "" && this.dataForm.ApproveRule != "") {
        this.msgToasts("审批人和审批规则不能同时存在!", "info")
        return false
      }
      return true
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      if (!this.ValidData()) {
        cb(false)
        return
      }
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          let _items = []
          _data.ApproveRule =
            _data.ApproveRule == "" ? null : _data.ApproveRule
          _items.push(_data)
          let _result = await ApproveUserSettingController.methods.upData({
            selected_items: _items,
          })

          if (_result.length > 0) {
            let data = _result[0].Result.Data[0][0]

            let _m = _.find(this.$refs.ApproveUserSettingRef.my_data, {
              id: data.id,
            })
            if (_m) {
              _m.ApproveTypeSettingId = data.ApproveTypeSettingId
              _m.DocumentCreateBy = data.DocumentCreateBy
              _m.ApproveLevel = data.ApproveLevel
              _m.Approver = data.Approver
              _m.isRole = data.isRole
              _m.ApproveRule = data.ApproveRule
              _m.is_valid = data.is_valid
            } else {
              this.$refs.ApproveUserSettingRef.AppendItems([data])
            }
            _this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true, true)
          } else {
            _this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
            cb(false)
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.state == "approved" || data.state == "unapproved") {
        cb(false)
        return
      } else if (data.state == "valid" || data.state == "invalid") {
        let _result = await ApproveUserSettingController.methods.upData(data)

        if (_result.length > 0) {
          ///成功
          _.each(data.selected_items, (t) => {
            let _m = _.find(this.$refs.ApproveUserSettingRef.my_data, {
              id: t.id,
            })
            if (_m) {
              _m.is_approved = _result[0].Result.Data[0][0].is_approved
            }
          })
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          cb(true, true)
        } else {
          ///失败
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      } else if (data.state == "deleted") {
        let _result = await ApproveUserSettingController.methods.RemoveData(
          data.selected_items
        )
        if (_result) {
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          this.$refs.ApproveUserSettingRef.RemoveItems(data.selected_items)
          cb(true)
        } else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      }
    },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
